import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['input', 'modal'];

  open() {
    this.modalTarget.classList.remove('hidden');
    this.inputTarget.focus();
    this.submit();
  }

  close() {
    this.modalTarget.classList.add('hidden');
    this.inputTarget.value = '';
  }

  submit() {
    clearTimeout(this._debounce);
    this._debounce = setTimeout(() => {
      const q = this.inputTarget.value;
      const frame = document.querySelector('turbo-frame#search-results');
      if (frame) frame.src = `/search?q=${encodeURIComponent(q)}`;
    }, 300);
  }
}
